/**
 * Created by andrey on 08.08.2025
 */

cc.TintTo = function (duration, red, green, blue) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._to = cc.color(0, 0, 0);
    this._from = cc.color(0, 0, 0);

    if (blue !== undefined) {
        this.initWithDuration(duration, red, green, blue);
    }
};

cc.TintTo.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.TintTo,

    initWithDuration: function (duration, red, green, blue) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            this._to = cc.color(red, green, blue);
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        this._from = this.target.color;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        const from = this._from, to = this._to;
        if (from) {
            this.target.setColor(
                cc.color(
                    from.r + (to.r - from.r) * dt,
                    from.g + (to.g - from.g) * dt,
                    from.b + (to.b - from.b) * dt
                )
            );
        }
    }
});

cc.tintTo = (duration, red, green, blue) => new cc.TintTo(duration, red, green, blue);
